import { parseISO, format } from 'date-fns';
import type { Locale } from 'date-fns';
import {
  ru, enUS, ptBR, es,
} from 'date-fns/locale';
import i18n from 'i18next';

export const DATE_FORMATS = {
  default: 'dd MMM HH:mm:ss',
  withYear: 'dd MMM yyyy HH:mm:ss',
  short: 'dd.MM.yyyy',
} as const;

type SupportedLang = 'ru' | 'en' | 'pt-BR' | 'es';

const LOCALES: Record<SupportedLang, Locale> = {
  ru,
  en: enUS,
  'pt-BR': ptBR,
  es,
};

const getLocale = (): Locale => {
  const lang = (i18n.language as SupportedLang) || 'en';
  return LOCALES[lang] || LOCALES.en;
};

type DateInput = string | Date | undefined;

export const parseISOToLocale = (date: DateInput): string | undefined => {
  if (!date) return undefined;

  const parsed = typeof date === 'string' ? parseISO(date) : date;
  return parsed.toLocaleString();
};

export const formatDateTime = (
  date: DateInput,
  dateFormat: string = DATE_FORMATS.default,
): string | undefined => {
  if (!date) return undefined;

  const parsed = typeof date === 'string' ? parseISO(date) : date;

  return format(parsed, dateFormat, {
    locale: getLocale(),
  });
};
